import { Entity } from "dexie";
import type DB from "./dbclass";

export type SingletonKey = "configuration" | "booth" | "userSettings" | "scanSettings" | "scanMode" | "lastSync";

export type ScanType = "entry" | "exit" | "section" | "booth";

export class Singleton extends Entity<DB> {
	[key: string]: any;
}

export class BoothConfig extends Singleton {
	apikey!: string;
	booth_mode_only!: boolean;
	allowed_booth_names!: string[];
}

export class ScannerConfiguration extends Singleton {
	apikey!: string;
	title!: string;
	expiration_time!: string;
	events!: string[];
	/** Venue sections available for section-scan mode, sourced from the API configuration. */
	sections!: Array<{ id: number; name: string; access_control: number | null }>;
}

export class ScanMode extends Singleton {
	mode!: ScanType;
	section!: number | null | undefined;
	sectionName!: string | null | undefined;
	timeTolerance!: string; // TODO: shouldn't this be a number??
	expiredTicketAcceptance!: boolean;
}

export class ScanSettings extends Singleton {
	scanDelay!: number;
	keepScanPopupOpen!: boolean;
	logging!: boolean;
	autoUpdate!: boolean;
	updateInterval!: boolean;
	device_name!: string;
	muted!: boolean;
}

export class UserSettings extends Singleton {
	language!: "fi" | "en";
	handedness!: "left" | "right";
	wakelock!: boolean;
}

export class LastSyncIds extends Singleton {
	lastTicketId!: number;
	lastScanId!: number;
	lastRevocationId!: number;
}

export class OfflineTicket extends Entity<DB> {
	id!: number;
	ticket_id!: number;
	scanned!: string;
	scan_type!: ScanType;
	section_id!: number | null;
	device_id!: string;
	device_label!: string;
	metadata!: Record<string, unknown> | null;
}

export class Ticket extends Entity<DB> {
	ticket_code!: string;
	id!: number;
	event_slug!: string;
	title!: string;
	product_id!: number;
	valid_from!: string;
	valid_until!: string;
}

export class Scan extends Entity<DB> {
	id!: number;
	ticket_id!: number;
	device_label!: string;
	scanned!: string;
	scan_type!: ScanType;
	section_id!: number | null;
	metadata!: Record<string, unknown> | null;
}

export class Revocation extends Entity<DB> {
	ticket_id!: number;
	revoked_at?: string;
	reason?: string;
}

export class Event extends Entity<DB> {
	slug!: string;
	event_name!: string;
	products!: {
		id: number;
		name: string;
		valid_from: string;
		valid_until: string;
		variants: {
			id: number;
			name: string;
		}[];
	}[];
	access_controls!: {
		id: number;
		name: string;
		products: number[];
		// bypass: string;
		// allow_guests: boolean;
		scan_options: {
			[key: string]: any; // TODO
		};
		[key: string]: any;
	}[];
	venuemap?: {
		id: number;
		title: string;
		access_control: number;
		sections: {
			id: number;
			name: string;
			access_control: number;
		}[];
	};
}

export class Product extends Entity<DB> {
	id!: number;
	event_slug!: string;
	product_category!: number;
	product_category_name!: string;
	name!: string;
	valid_from!: string;
	valid_until!: string;
}
